module.exports = __webpack_public_path__ + "static/media/betterLogo.0f757e20.png";